"use client";

import { useState, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";

export function PageShare({ articleURL }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const shareOptions = [
    {
      label: "Copy link",
      icon: <Icon icon="hugeicons:copy-link" className="text-xl" />,
      action: () => navigator.clipboard.writeText(articleURL),
    },
    {
      label: "Share on X",
      icon: (
        <Icon
          icon="fa6-brands:square-x-twitter"
          className="text-xl text-slate-600"
        />
      ),
      url: `https://twitter.com/share?url=${encodeURIComponent(articleURL)}`,
    },
    {
      label: "Share on Facebook",
      icon: <Icon icon="mdi:facebook" className="text-xl text-slate-600" />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        articleURL
      )}`,
    },
    {
      label: "Share on LinkedIn",
      icon: <Icon icon="mdi:linkedin" className="text-xl text-slate-600" />,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        articleURL
      )}`,
    },
  ];
  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="p-2 text-slate-600 hover:text-slate-800"
      >
        <Icon icon="iconamoon:share-2-light" className="text-xl" />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg">
          {shareOptions.map((option, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 p-2 hover:bg-gray-100"
            >
              {option.action ? (
                <button
                  onClick={option.action}
                  className="w-full flex items-center space-x-2 text-left"
                >
                  {option.icon}
                  <span>{option.label}</span>
                </button>
              ) : (
                <a
                  href={option.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2"
                >
                  {option.icon}
                  <span>{option.label}</span>
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
